export default "__VITE_ASSET__DBnixhlc__"